export const ORG_OPTIONS = [
  { value: "ministry", label: "Flames of Fire World Evangelism" },
  { value: "church", label: "Tabernacle of Grace Church" },
];

export const CATEGORY_OPTIONS = [
  "Mega Healing Crusades", "Jesus On The Way", "Jesus Caravan", "Youth Outreach",
  "Prison Ministry", "Church", "Missions", "Training", "Conferences",
].map((c) => ({ value: c, label: c }));

export const ICON_OPTIONS = [
  "flame", "route", "truck", "graduation-cap", "lock", "users", "send",
  "crown", "briefcase", "music", "clipboard-check", "megaphone", "heart", "handshake", "hands",
].map((i) => ({ value: i, label: i }));

// Generic content resources managed via ResourceManager
export const RESOURCES = {
  "evangelism-activities": {
    title: "Evangelism Activities",
    singular: "Activity",
    reorder: true,
    list: ["title", "status", "featured"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "slug", label: "Slug (URL id)", type: "text", help: "e.g. mega-healing-crusades" },
      { name: "icon", label: "Icon", type: "select", options: ICON_OPTIONS },
      { name: "image", label: "Image", type: "image" },
      { name: "video_url", label: "Video URL", type: "text" },
      { name: "cta_label", label: "CTA Label", type: "text" },
      { name: "cta_link", label: "CTA Link", type: "text" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "featured", label: "Featured", type: "switch" },
    ],
  },
  departments: {
    title: "Departments",
    singular: "Department",
    reorder: true,
    list: ["name", "leader", "status"],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "icon", label: "Icon", type: "select", options: ICON_OPTIONS },
      { name: "leader", label: "Leader", type: "text" },
      { name: "image", label: "Image", type: "image" },
      { name: "contact", label: "Contact", type: "text" },
      { name: "responsibilities", label: "Responsibilities", type: "list" },
      { name: "description", label: "Description", type: "textarea" },
    ],
  },
  leadership: {
    title: "Leadership",
    singular: "Leader",
    reorder: true,
    list: ["name", "role", "status"],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "role", label: "Position / Role", type: "text" },
      { name: "association", label: "Association", type: "select", options: ORG_OPTIONS },
      { name: "image", label: "Photo", type: "image" },
      { name: "bio", label: "Biography", type: "richtext" },
      { name: "social_links", label: "Social Links", type: "objectlist", subfields: [
        { name: "label", label: "Label", type: "text" }, { name: "url", label: "URL", type: "text" },
      ] },
    ],
  },
  sermons: {
    title: "Sermons",
    singular: "Sermon",
    list: ["title", "speaker", "organization", "status", "featured"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "speaker", label: "Speaker", type: "text" },
      { name: "date", label: "Date", type: "date" },
      { name: "scripture", label: "Scripture", type: "text" },
      { name: "category", label: "Category", type: "text" },
      { name: "organization", label: "Belongs To", type: "select", options: ORG_OPTIONS },
      { name: "thumbnail", label: "Thumbnail", type: "image" },
      {
        name: "video_url",
        label: "YouTube URL",
        type: "text",
        required: true,
        help: "Paste a youtube.com/watch, youtu.be, YouTube Shorts, or embed URL.",
      },
      { name: "audio_url", label: "Audio URL", type: "text" },
      { name: "duration", label: "Duration", type: "text" },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "description", label: "Description", type: "richtext" },
      { name: "featured", label: "Featured", type: "switch" },
    ],
  },
  podcasts: {
    title: "Podcasts",
    singular: "Episode",
    list: ["title", "episode_number", "host", "status"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "episode_number", label: "Episode #", type: "number" },
      { name: "host", label: "Host", type: "text" },
      { name: "speaker", label: "Speaker / Guest", type: "text" },
      { name: "date", label: "Date", type: "date" },
      { name: "category", label: "Category", type: "text" },
      { name: "cover_image", label: "Cover Image", type: "image" },
      { name: "audio_url", label: "Audio URL", type: "text" },
      { name: "external_links", label: "External Links", type: "objectlist", subfields: [
        { name: "label", label: "Label", type: "text" }, { name: "url", label: "URL", type: "text" },
      ] },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "description", label: "Description", type: "richtext" },
    ],
  },
  gallery: {
    title: "Gallery",
    singular: "Gallery Item",
    list: ["caption", "category", "status"],
    fields: [
      { name: "caption", label: "Caption", type: "text" },
      { name: "image", label: "Image", type: "image", required: true },
      { name: "album", label: "Album", type: "text" },
      { name: "category", label: "Category", type: "select", options: CATEGORY_OPTIONS },
      { name: "date", label: "Date", type: "date" },
      { name: "tags", label: "Tags", type: "tags" },
    ],
  },
  videos: {
    title: "Videos",
    singular: "Video",
    list: ["title", "category", "status", "featured"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "select", options: CATEGORY_OPTIONS },
      { name: "date", label: "Date", type: "date" },
      { name: "thumbnail", label: "Thumbnail", type: "image" },
      {
        name: "video_url",
        label: "YouTube URL",
        type: "text",
        required: true,
        help: "Paste a youtube.com/watch, youtu.be, YouTube Shorts, or embed URL.",
      },
      { name: "tags", label: "Tags", type: "tags" },
      { name: "description", label: "Description", type: "textarea" },
      { name: "featured", label: "Featured", type: "switch" },
    ],
  },
  announcements: {
    title: "Announcements",
    singular: "Announcement",
    list: ["title", "category", "status", "featured"],
    scheduling: true,
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "text" },
      { name: "author", label: "Author", type: "text" },
      { name: "date", label: "Date", type: "date" },
      { name: "image", label: "Image", type: "image" },
      { name: "content", label: "Content", type: "richtext" },
      { name: "featured", label: "Featured", type: "switch" },
    ],
  },
  events: {
    title: "Events",
    singular: "Event",
    list: ["title", "date", "location", "status"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "category", label: "Category", type: "text" },
      { name: "date", label: "Date", type: "date" },
      { name: "time", label: "Time", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "image", label: "Image", type: "image" },
      { name: "organizer", label: "Organizer", type: "text" },
      { name: "contact", label: "Contact", type: "text" },
      { name: "registration_link", label: "Registration Link", type: "text" },
      { name: "association", label: "Associated With", type: "select", options: ORG_OPTIONS },
      {
        name: "description",
        label: "Description",
        type: "richtext",
        help: "Basic formatting is supported and safely cleaned before publishing.",
      },
    ],
  },
  testimonials: {
    title: "Testimonials",
    singular: "Testimonial",
    list: ["title", "name", "status"],
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "name", label: "Name", type: "text", required: true },
      { name: "date", label: "Date", type: "date" },
      { name: "campaign", label: "Campaign / Event", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "photo", label: "Photo", type: "image" },
      { name: "story", label: "Story", type: "richtext" },
    ],
  },
  campaigns: {
    title: "Campaigns",
    singular: "Campaign",
    list: ["title", "type", "location", "status"],
    fields: [
      { name: "title", label: "Title", type: "text", required: true },
      { name: "type", label: "Type", type: "select", options: [
        "Mega Healing Crusades", "Jesus On The Way Crusades", "Jesus Caravan", "Youth Crusade Outreach",
        "Prison Ministry", "One-on-One Evangelism", "Training, Equipping and Sending Evangelists",
      ].map((v) => ({ value: v, label: v })) },
      { name: "location", label: "Location", type: "text" },
      { name: "start_date", label: "Start Date", type: "date" },
      { name: "end_date", label: "End Date", type: "date" },
      { name: "image", label: "Main Image", type: "image" },
      { name: "description", label: "Description", type: "richtext" },
    ],
  },
  statistics: {
    title: "Impact Statistics",
    singular: "Statistic",
    reorder: true,
    list: ["label", "value", "status"],
    fields: [
      { name: "label", label: "Label", type: "text", required: true, help: "e.g. Nations Reached" },
      { name: "value", label: "Value", type: "text", required: true, help: "e.g. 12 or 12,000+" },
    ],
  },
  followups: {
    title: "Follow-Up (Harvest)",
    singular: "Follow-Up Record",
    list: ["reference", "location", "followup_status"],
    fields: [
      { name: "reference", label: "Reference ID", type: "text" },
      { name: "date", label: "Date", type: "date" },
      { name: "campaign", label: "Campaign / Event", type: "text" },
      { name: "activity", label: "Evangelism Activity", type: "text" },
      { name: "location", label: "Location", type: "text" },
      { name: "counsellor", label: "Counsellor", type: "text" },
      { name: "local_church", label: "Local Church", type: "text" },
      { name: "followup_status", label: "Follow-Up Status", type: "select", options: [
        "New", "Contacted", "Follow-up in progress", "Handed to local church", "Discipleship", "Completed",
      ].map((v) => ({ value: v, label: v })) },
      { name: "followup_date", label: "Follow-Up Date", type: "date" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  counsellors: {
    title: "Counsellors",
    singular: "Counsellor",
    list: ["name", "status", "assigned_campaign"],
    fields: [
      { name: "name", label: "Name", type: "text", required: true },
      { name: "contact", label: "Contact Information", type: "text" },
      { name: "assigned_campaign", label: "Assigned Campaign", type: "text" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
  partners: {
    title: "Local Church Partners",
    singular: "Partner",
    list: ["name", "location", "partnership_status"],
    fields: [
      { name: "name", label: "Church / Ministry Name", type: "text", required: true },
      { name: "location", label: "Location", type: "text" },
      { name: "leader", label: "Pastor / Leader", type: "text" },
      { name: "contact", label: "Contact", type: "text" },
      { name: "email", label: "Email", type: "text" },
      { name: "website", label: "Website", type: "text" },
      { name: "partnership_status", label: "Partnership Status", type: "select", options: [
        "Prospect", "Active", "Inactive",
      ].map((v) => ({ value: v, label: v })) },
      { name: "is_public", label: "Show publicly", type: "switch" },
      { name: "notes", label: "Notes", type: "textarea" },
    ],
  },
};

// Singleton editors
export const SINGLETONS = {
  ministry: {
    title: "Ministry",
    fields: [
      { name: "logo", label: "Logo", type: "image" },
      { name: "name", label: "Ministry Name", type: "text" },
      { name: "short_name", label: "Short Name", type: "text" },
      { name: "type", label: "Description / Type", type: "text" },
      { name: "slogan", label: "Slogan", type: "text" },
      { name: "who_we_are", label: "Who We Are", type: "textarea" },
      { name: "history", label: "History", type: "textarea" },
      { name: "mandate", label: "Mandate", type: "text" },
      { name: "mandate_imagery", label: "Mandate Imagery", type: "text" },
      { name: "scripture_reference", label: "Key Scripture Reference", type: "text" },
      { name: "scripture_text", label: "Key Scripture Text", type: "textarea" },
      { name: "mission", label: "Mission", type: "richtext" },
      { name: "vision", label: "Vision", type: "richtext" },
      { name: "values", label: "Core Values", type: "list" },
      { name: "contact", label: "Contact Info", type: "object", subfields: [
        { name: "email", label: "Email", type: "text" },
        { name: "phone", label: "Phone", type: "text" },
        { name: "address", label: "Address", type: "text" },
      ] },
      { name: "social_links", label: "Social Links", type: "objectlist", subfields: [
        { name: "label", label: "Label", type: "text" }, { name: "url", label: "URL", type: "text" },
      ] },
    ],
  },
  church: {
    title: "Tabernacle of Grace Church",
    fields: [
      { name: "name", label: "Church Name", type: "text" },
      { name: "tagline", label: "Tagline", type: "text" },
      { name: "image", label: "Image", type: "image" },
      { name: "about", label: "About", type: "textarea" },
      { name: "mission", label: "Mission", type: "richtext" },
      { name: "vision", label: "Vision", type: "richtext" },
      { name: "service_times", label: "Service Times", type: "list" },
      { name: "location", label: "Location", type: "text" },
      { name: "leadership", label: "Church Leadership", type: "objectlist", subfields: [
        { name: "name", label: "Name", type: "text" }, { name: "role", label: "Role", type: "text" },
        { name: "bio", label: "Bio", type: "text" }, { name: "image", label: "Photo", type: "image" },
      ] },
      { name: "departments", label: "Departments", type: "objectlist", subfields: [
        { name: "name", label: "Name", type: "text" }, { name: "description", label: "Description", type: "text" },
      ] },
    ],
  },
  giving: {
    title: "Giving",
    fields: [
      { name: "title", label: "Title", type: "text" },
      { name: "intro", label: "Intro", type: "textarea" },
      { name: "note", label: "Note", type: "textarea" },
      { name: "methods", label: "Giving Methods", type: "objectlist", subfields: [
        { name: "name", label: "Method Name", type: "text" }, { name: "details", label: "Details", type: "text" },
      ] },
    ],
  },
  settings: {
    title: "Site Settings",
    fields: [
      { name: "site_name", label: "Site Name", type: "text" },
      { name: "footer_note", label: "Footer Note", type: "text" },
      { name: "social_links", label: "Social Links", type: "objectlist", subfields: [
        { name: "label", label: "Label", type: "text" }, { name: "url", label: "URL", type: "text" },
      ] },
    ],
  },
};
